import React from 'react';
import NavBar from '../components/navbar';
import ExerciseCard from '../components/exercisecard';
import FirebaseConnector from '../data/FirebaseConnector';
import { CircularProgress } from '@material-ui/core';
import '../styles/exerciselist.css';
import history from '../components/history';

const loadingClass = "exerciselist loading";

class ExerciseList extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            exercises: null,
            exercisesLoaded: false,
        };
    }

    async componentDidMount() {
        const db = new FirebaseConnector();
        const user = await db.getUserData();
        const eids = [];
        if (!this.props.hideShown) {
            eids.push(...await db.getExerciseIds());
        } else {
            if(!user) {
                history.push('/exercises');
                return;
            }
            const roles = await user.getRoles();
            if(!roles.moderator) {
                history.push('/exercises');
                return;
            }
        }
        if (user) {
            const roles = await user.getRoles();
            if (roles.moderator) {
                eids.push(...await db.getExerciseIds(true));
            };
        }
        var from = this.props.from;
        if (!from) from = 0;
        var to = this.props.to;
        if (!to) to = from + 30;
        const e = await db.getExercises(eids.slice(from, to));
        await this.setState({
            exercises: e,
            exercisesLoaded: true,
        });
    }

    render() {
        if (!this.state.exercisesLoaded) {
            return (
                <>
                    <NavBar />
                    <CircularProgress className={loadingClass} />
                </>
            );
        }
        return (
            <>
                <NavBar />
                {this.state.exercises.map((e) => { return (<ExerciseCard key={e.id} exercise={e} />) })}
                {/* <ExerciseCard exercise={new Exercise('id', 'title', 'uid', 'problem', 'solution', [3, 5, 1], 1589048428264, [5, 6, 9], true)} />
                <ExerciseCard exercise={new Exercise('id', 'title2', 'uid', 'problem23', 'solutionas', [3, 0, 1], 1589048428264, [5, 6, 7, 9], true)} /> */}
            </>
        );
    }

}

export default ExerciseList;